var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.61704 0.7988C2.1285 0.287337 2.82219 0 3.54551 0H11.1407C11.2787 0 11.3907 0.111929 11.3907 0.25V3.78906C11.3907 4.89363 12.2864 5.78906 13.391 5.78906H16.9314C17.0695 5.78906 17.1819 5.90099 17.1819 6.03906V17.2727C17.1819 17.996 16.8945 18.6897 16.3831 19.2012C15.8716 19.7127 15.1779 20 14.4546 20H3.54551C2.82219 20 2.1285 19.7127 1.61704 19.2012C1.10557 18.6897 0.818237 17.996 0.818237 17.2727V2.72727C0.818237 2.00396 1.10557 1.31026 1.61704 0.7988ZM13.0632 0.536861L16.6415 4.11513C16.7989 4.27262 16.6874 4.5419 16.4647 4.5419H13.6364C13.0841 4.5419 12.6364 4.09419 12.6364 3.5419V0.713637C12.6364 0.490911 12.9057 0.37937 13.0632 0.536861Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.4c331031be80a4bcb5f4e876da132289.svg";
export { ForwardRef as ReactComponent };